<template>
  <div :class="'qc-sms-login qc-light-light-' + hightLightFormItem" v-show="props.show">
    <div :class="'qc-form-item ' + (showPhoneSelect ? 'selected-box' : '')">
      <div class="qc-form-item-label">
        <div class="qc-sprites qc-sprites-phone_icon"></div>
      </div>
      <div class="qc-form-input">
        <input type="text"
          style="width: 100%;"
          placeholder="请输入手机号"
          name="phone"
          v-model.trim="phone"
          @input="handleInput"
          autocomplete="off"
          @focus="() => onFocus(1)"
          @blur="onBlur" />
      </div>
      <div v-if="phoneList.length" class="qc-form-operation" @click="togglePhoneSelect()">
        <div class="qc-sprites qc-sprites-more_icon"></div>
      </div>
      <div class="qc-select-box">
        <div class="qc-select-mask" @click="togglePhoneSelect()"></div>
        <div class="qc-select-line"></div>
        <ul>
          <li v-for="(item, idx) in phoneList" :key="idx" class="qc-select-options-item" @click="selectPhone(item)">
            <span>{{ item }}</span>
            <b class="qc-options-delete" @click.stop="removePhoneItem(item)"></b>
          </li>
        </ul>
      </div>
    </div>
    <div class="qc-form-item qc-code-form-item">
      <div class="qc-form-item-label">
        <div class="qc-sprites qc-sprites-safe_icon"></div>
      </div>
      <div class="qc-form-input">
        <input
          type="text"
          v-model.trim="code"
          placeholder="请输入验证码"
          name="code"
          autocomplete="off"
          @focus="() => onFocus(2)"
          @blur="onBlur" />
      </div>
      <div class="qc-form-operation">
        <div v-if="canSendCode" class="qc-send-code-text" @click="sendCode()">发送验证码</div>
        <div v-else class="qc-send-code-disable">{{ countdown + 's 后重发' }}</div>
      </div>
    </div>
    <div :class="'qc-default-btn qc-confirm-btn ' + (isFormInvalid ? 'qc-disable-btn' : '')" @click="onLogin()">登录</div>
    <div class="qc-agreement-box">
      <div class="qc-agreement-left" @click="toggleAgreement()">
        <div v-if="isCheckedAgreement" class="qc-sprites qc-sprites-selected_icon"></div>
        <div v-else class="qc-sprites qc-sprites-not_select_icon"></div>
      </div>
      <div class="qc-agreement-right"><span @click="toggleAgreement()">阅读并同意</span><a 
        :href="AGREEMENT.SERVICE" target="_blank">{{ AGREEMENT.SERVICE_LABEL }}</a>、<a 
        :href="AGREEMENT.PRIVACY" target="_blank">{{ AGREEMENT.PRIVACY_LABEL }}</a>、<a 
        :href="AGREEMENT.CHILD_PRIVACY" target="_blank">{{ AGREEMENT.CHILD_PRIVACY_LABEL }}</a>
      </div>
    </div>
    <div id="captcha-element"></div>
  </div>
</template>
<script lang="ts" setup>
import { ref, computed, watch } from 'vue';
import { Toast } from '../../subComponents/Toast/index';
import ApiManager from '../../core/api/index';
import { maskPhone, loadScript } from '../../core/utils/index';
import { LOGIN_TYPE, VERIFY_CODE_TYPE, VERIFY_CODE_CHANNEL, AGREEMENT } from '../../core/constants/index';
import type { SMSLoginProps } from '../types';

const props = withDefaults(defineProps<SMSLoginProps>(), {});

const showPhoneSelect = ref(false);
const togglePhoneSelect = () => {
  showPhoneSelect.value = !showPhoneSelect.value;
};

const isCheckedAgreement = ref(false);
const toggleAgreement = () => {
  isCheckedAgreement.value = !isCheckedAgreement.value;
};

const phone = ref('');
const code = ref('');
const captchaVerifyCode = ref('');
const phoneError = computed(() => {
  if (!phone.value) {
    return '请输入手机号';
  }
  if (!new RegExp('^\\+{0,1}[0-9]+$').test(phone.value)) {
    return '请输入正确的手机号';
  }
});
const codeError = computed(() => {
  if (!code.value) {
    return '请输入验证码';
  }
  if (!new RegExp("^\\d{6}$").test(code.value)) {
    return '请输入正确的验证码';
  }
});
const selectPhone = (item: string) => {
  phone.value = item;
  showPhoneSelect.value = false;
};

const handleInput = () => {};

const isFormInvalid = computed(() => {
  return !!phoneError.value || !!codeError.value || !isCheckedAgreement.value;
});

// 倒计时
let interval: any;
const countdown = ref(60);
const canSendCode = ref(true);
const countDown = () => {
  if (countdown.value <= 0) {
    countdown.value = 60;
    canSendCode.value = true;
    clearInterval(interval);
  } else {
    --countdown.value;
  }
};

// 加载阿里云二次验证
const initAliyunCaptcha = (SceneId: string, EncryptedSceneId: string) => {
  if (!window.initAliyunCaptcha) {
    Toast("图形验证码加载失败，请刷新页面重试");
    return;
  }
  window.initAliyunCaptcha({
    SceneId,
    EncryptedSceneId,
    mode: "popup",
    element: "#captcha-element",
    success: function (captchaVerifyParam: string) {
      captchaVerifyCode.value = captchaVerifyParam;
      sendCode();
    },
    fail: function () {},
    onClose: function () {},
    getInstance: function (instance: any) {
      instance.show();
    },
  });
};

// 发送验证码
const sendCode = async () => {
  // 没有填写手机号
  if (phoneError.value) {
    Toast(phoneError.value);
    return;
  }
  canSendCode.value = false;

  await ApiManager.getInstance().user.sendVerificationCode({
    type: VERIFY_CODE_TYPE.PHONE,
    channel: VERIFY_CODE_CHANNEL.LOGIN,
    number: phone.value,
    captcha_verify_param: captchaVerifyCode.value || '',
  }).then((response) => {
    if (response.code === 200) {
      Toast('发送成功');
      interval = setInterval(countDown, 1000);
      captchaVerifyCode.value = '';
    } else if (response.code === 407) {
      const { captcha_encrypted_scene_id, captcha_scene_id } = response.metadata;
      canSendCode.value = true;
      captchaVerifyCode.value = '';
      initAliyunCaptcha(captcha_scene_id, captcha_encrypted_scene_id);
    } else {
      canSendCode.value = true;
      Toast(response.message);
    }
  }).catch((error) => {
    canSendCode.value = true;
    Toast(error.message);
  });
};

const phoneListStr = localStorage.getItem('QC_PLATFORM_UI_PHONE_LIST');
const phoneList = ref((phoneListStr && props.autoDown) ? JSON.parse(phoneListStr) : []);

const addPhoneItem = (phoneItem: string) => {
  if (!props.autoDown) { return; }
  const phoneIndex = phoneList.value.findIndex((item:string) => item === phoneItem);
  if (phoneIndex === -1) {
    phoneList.value.unshift(phoneItem);
    phoneList.value.length > 5 && (phoneList.value.length = 5);
  } else {
    phoneList.value.splice(phoneIndex, 1);
    phoneList.value.unshift(phoneItem);
  }
  localStorage.setItem('QC_PLATFORM_UI_PHONE_LIST', JSON.stringify(phoneList.value));
};
const removePhoneItem = (phoneItem: string) => {
  const phoneIndex = phoneList.value.findIndex((item:string) => item === phoneItem);
  if (phoneIndex !== -1) {
    phoneList.value.splice(phoneIndex, 1);
  }
  if (phoneList.value.length === 0) {
    showPhoneSelect.value = false;
  }
  localStorage.setItem('QC_PLATFORM_UI_PHONE_LIST', JSON.stringify(phoneList.value));
};

const onLogin = async () => {
  if (phoneError.value) {
    Toast(phoneError.value);
    return;
  } else if (codeError.value) {
    Toast(codeError.value);
    return;
  } else if (!isCheckedAgreement.value) {
    props.openWarmTip();
    return;
  }

  await ApiManager.getInstance().user.login({
    type: LOGIN_TYPE.PHONE,
    code: code.value,
    account: phone.value
  }).then((response) => {
    if (response.code === 200) { // 登录成功
      const { access_token } = response.metadata;
      props.onFinish(access_token, { loginWay: 'sms', data: { phone: maskPhone(phone.value) } });
      addPhoneItem(phone.value);
      phone.value = '';
      code.value = '';
      isCheckedAgreement.value = false;
    } else {
      Toast(response.message);
    }
  }).catch((error) => {
    Toast(error.message);
  });
};

// 高亮的表单行
const hightLightFormItem = ref(0);
// 表单聚焦
const onFocus = (rowIdx?: number) => {
  rowIdx && (hightLightFormItem.value = rowIdx);
};
const onBlur = () => {
  hightLightFormItem.value = 0;
};

watch(() => props.show, (newVal) => {
  if (!newVal) {
    props.onChangeAccountCache(phone.value);
    // phone.value = '';
    showPhoneSelect.value = false;
    code.value = '';
    isCheckedAgreement.value = false;
    hightLightFormItem.value = 0;
  }
});
watch(() => props.accountCache, (newVal) => {
  phone.value = newVal;
});

watch(() => props.isAgreement, (newVal) => {
  isCheckedAgreement.value = newVal;
});
</script>